import React, { useEffect } from 'react'

import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from 'src/components/Barcode'

import { convertGS1 } from './utils'

const useStyles = makeStyles({
  label: {
    width: '4in',
    height: '6in',
  },
  zoneA: {
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '1.5in',
    fontSize: '14px',
  },
  zoneB: {
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2.5in',
    fontSize: '14px',
  },
  zoneC: {
    borderTop: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '2.5in',
  },
  zoneD: {
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '1.5in',
  },
  zoneE: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '4in',
  },
  zoneF: {
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    height: '1in',
    width: '4in',
  },
  zoneG: {
    borderTop: '1px solid black',
    height: '2in',
    width: '4in',
  },
  header: {
    fontSize: '12px',
    fontWeight: 'bold',
    paddingLeft: '3px',
  },
  address: {
    lineHeight: '1.0',
    paddingLeft: '10px',
  },
  from: {
    lineHeight: '1.0',
    paddingLeft: '5px',
    fontSize: '10px',
  },
  carrier: {
    fontWeight: 'bold',
    paddingLeft: '5px',
  },
  to: {
    lineHeight: '1.0',
    fontWeight: 'bold',
    paddingLeft: '10px',
  },
  container: {
    top: 'auto',
    bottom: 0,
  },
  center: {
    flexGrow: 1,
    textAlign: 'center',
  },
})

interface FleetFarmLabelProps {
  zoneA: string[]
  zoneB: string[]
  zoneC: string
  zoneD: string
  zoneE: string
  zoneF: {
    vpn: string
    qty: number
    pallet_number: [number, number]
  }
  zoneG: string
}

interface Props {
  data:FleetFarmLabelProps
  onReadyToPrint?: () => void
}


export const FleetFarmCaseLabel = (props: Props) => {
  const { data, onReadyToPrint } = props
  const ssccBarcode = { barcode: convertGS1(data.zoneG, 2), type: 'gs1-128', displayName: '' }
  const shipToBarcode = { barcode: convertGS1(data.zoneC, 3), type: 'gs1-128', displayName: '' }
  const classes = useStyles()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className={`always-page-break ${classes.label}`}>
      <div className="print-page">
        <Box className={classes.label}>
          <Grid container spacing={0}>
            <Grid item>
              <Box className={classes.zoneA}>
                <Typography className={classes.header}>FROM:</Typography>
                {data.zoneA.map((line) => (
                  <Typography key={line} className={classes.from}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneB}>
                <Typography className={classes.header}>TO:</Typography>
                {data.zoneB.map((line) => (
                  <Typography key={line} className={classes.to}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneC}>
                <Grid item xs={12}>
                  <Typography className={classes.header}>SHIP TO POST:</Typography>
                </Grid>
                <Box display="flex" justifyContent="center">
                  <Typography variant="h6">{shipToBarcode.barcode}</Typography>
                </Box>
                <Box ml={6} mr={6}>
                  <Barcode barcode={shipToBarcode} scale={2} height={9} />
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneD} display="flex" flexDirection="column">
                <Typography className={classes.header}>LOCATION ID:</Typography>
                <Box display="flex" alignItems="center" justifyContent="center" flexGrow={2}>
                  <Typography variant="h1">{data.zoneD}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Box
                className={classes.zoneE}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="h2">PO Number: {data.zoneE}</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box className={classes.zoneF} px={2} pt={2}>
                <Typography variant="h3">VPN: {data.zoneF.vpn}</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box className={`${classes.zoneG} ${classes.container}`}>
                <Typography className={classes.header}>Serial Shipping Container Code:</Typography>
                <Box display="flex" justifyContent="center">
                  <Typography variant="h3">{ssccBarcode.barcode}</Typography>
                </Box>
                <Box ml={5} mr={5}>
                  <Barcode barcode={ssccBarcode} scale={2} height={20} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  )
}
